export default __webpack_public_path__ + "static/media/first_tab_howitwork.375c2546.png";